import React from 'react';
import ReactDOM from 'react-dom/client';
import PredictionsApp from './predictions/PredictionsApp';
import PerformingReportTemplate from './predictions/decks/reports/report_template/PerformingReportTemplate';
import ExecutiveSummaryReport from './predictions/decks/reports/index';
import './styles/tailwind.css';

function trackPageView(path) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  const page_path = path || (window.location.pathname + window.location.search);
  window.gtag('event', 'page_view', { page_path });
}

function resolveRoute() {
  if (typeof window === 'undefined') {
    return { type: 'predictions', deckId: '2029' };
  }
  const parts = window.location.pathname.split('/').filter(Boolean);
  const root = parts[0] || '';
  if (root === 'predictions' && parts[1] === 'reports') {
    return { type: 'report', slug: parts[2] || 'index' };
  }
  if (root === 'reports') {
    return { type: 'report', slug: parts[1] || 'index' };
  }
  if (root === 'predictions') {
    return { type: 'predictions', deckId: parts[1] || '2029' };
  }
  return { type: 'predictions', deckId: '2029' };
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

const root = ReactDOM.createRoot(rootEl);
const route = resolveRoute();

if (route.type === 'report') {
  trackPageView();
  const slug = route.slug;
  if (slug === 'index' || slug === 'summary') {
    root.render(<ExecutiveSummaryReport />);
  } else {
    root.render(<PerformingReportTemplate reportSlug={slug} />);
  }
} else {
  root.render(<PredictionsApp deckId={route.deckId} />);
}
